import barba from '@barba/core';
import { enableBodyScroll } from 'body-scroll-lock';
import { gsap } from 'gsap';

import { replaceBodyClasses, scrollPosition, wait } from '../global/helpers';
import { $Elements, BrowserEvents, Classes, Elements, TransitionDurations, TransitionnableLinks } from '../global/constants';

;(function($) {

	// ---------- Barba Initialisation ----------

	barba.init({
		debug: false,
		preventRunning: true,
		prevent: ({ el }) => !$(el).is(TransitionnableLinks),
		transitions: [{
			sync: true,
			once: async() => $Elements.window.on('load', () => {
				$Elements.document.trigger(BrowserEvents.page.loaded);
				pageLoaded();
				Elements.MainWrapper.classList.remove('initial-load');
			}),
			enter: async() => $Elements.document.one(BrowserEvents.page.transition, pageLoaded),
			leave: async(data) => {

				Elements.LoadingBar.classList.add(Classes.loading);
				Elements.LoadingOverlay.classList.add(Classes.loading);
				document.body.classList.add(Classes.leaving);
				data.current.container.classList.add(Classes.leaving);

				await defaultTransition(data);

				return true;
			},
			after: async(data) => {

				window.scrollTo(0, 0);
				replaceBodyClasses(data.next);
				$Elements.document.trigger(BrowserEvents.page.transition);

				return true;
			}
		}]
	});

	// ---------- Transitions ----------

	async function defaultTransition(data) {

		Elements.MainWrapper.dataset.activeMenu = data.next.container.dataset.activeMenu;
		Elements.MainWrapper.dataset.activeColor = data.next.container.dataset.color;
		document.body.dataset.color = data.next.container.dataset.color;

		await wait(TransitionDurations.page);

		const scroll = scrollPosition();
		data.next.container.style.top = scroll.scrollTop + 'px';

		if(document.body.classList.contains(Classes.menuOpen)) {
			document.body.classList.remove(Classes.menuOpen);
			enableBodyScroll(Elements.MenuWrapper);
		}

		gsap.set(data.current.container, { opacity: 0 });

		await wait(100);

		window.scrollTo(0, 0);
		data.next.container.style.top = 0;

		return true;
	}

	async function pageLoaded() {

		document.body.dataset.color = Elements.PageWrapper.dataset.color;
		$Elements.document.trigger(BrowserEvents.page.enter);
		Elements.MainWrapper.classList.remove(Classes.loading);
		Elements.LoadingBar.classList.remove(Classes.loading);
		Elements.LoadingOverlay.classList.remove(Classes.loading);

		const heroSection = document.querySelector('.hero-section');

		if(heroSection) {

			heroSection.classList.add(Classes.active);

			const heroSectionContent = heroSection.querySelector('.content');

			if(heroSectionContent) {

				await wait(TransitionDurations.page * 1.5);

				[...heroSectionContent.children].map(async(item, index) => {
					await wait(200 * index);
					item.classList.add(Classes.active);
				});
			}
		}

		return true;
	}

}(jQuery));
